<div class="fileUploadContainer">
  <div class="header hdr">
    <h5><span class="animateH5">AI Assist</span></h5>
  </div>
  <div id="botWrapper">
    <div class="col">
      <div id="chat-content-wrapper">
        <div class="bot-middle-content">
          <div class="position-relative">
            <div class="chat-header">
              <div id="botinput-wrapper">
                <div id="chat-message-enter-box">
                  <div id="chatForm">
                    <app-autocomplete
                      (setautoComplete)="setautoComplete($event)"
                      [autoSearchDafaultValue]="autoSearchDafaultValue"
                      [suggestionEnable]="suggestionEnable"
                      [suggestionList]="suggestionList"
                      [defaultSelectLanguage]="language"
                    ></app-autocomplete>
                  </div>

                  <ul id="chat-tools">
                    <li>
                      <i
                        class="fa fa-paper-plane"
                        [ngClass]="{ disabled: autoSearchDafaultValue == '' }"
                        (click)="save()"
                        (keydown.enter)="save()"
                        (keydown.space)="save()"
                      ></i>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="chat-list-content">
          @if (chatbotData.length > 0) {
            <div id="chat-list">
              @for (
                items of chatbotData;
                track items;
                let i = $index;
                let even = $even;
                let odd = $odd
              ) {
                <app-bot
                  [data]="items"
                  [index]="i"
                  [speakeLanguage]="language"
                ></app-bot>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
